import * as api from "../api";
import * as actionsType from "./actionsType";
import { errorHandler } from "./general";

export const getMobileUpdate = (history) => async (dispatch) => {
  try {
    dispatch({
      type: actionsType.SET_LOADING,
      payload: true,
    });
    dispatch({ type: actionsType.GET_MOBILE_UPDATE, payload: null });
    const { data } = await api.getMobileUpdate();
    dispatch({ type: actionsType.GET_MOBILE_UPDATE, payload: data.data });
    dispatch({
      type: actionsType.SET_LOADING,
      payload: false,
    });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const updateMobileData = (data, history) => async (dispatch) => {
  try {
    dispatch({
      type: actionsType.SET_LOADING,
      payload: true,
    });
    await api.updateMobileData(data);
    dispatch(getMobileUpdate(history));
    dispatch({
      type: actionsType.SET_LOADING,
      payload: false,
    });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};
